module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAHklEQVQ4T2NkYGBoZSADMI5qxB1qo4GDJ0UNocABACOAB1WfpqAGAAAAAElFTkSuQmCC"